export default "__VITE_PUBLIC_ASSET__e0c848e3__"